import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "kn-width-full" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col-12 p-md-10" }
const _hoisted_4 = { class: "p-float-label" }
const _hoisted_5 = {
  for: "activityName",
  class: "kn-material-input-label"
}
const _hoisted_6 = { class: "p-field p-md-2" }
const _hoisted_7 = { class: "table-header" }
const _hoisted_8 = { class: "p-input-icon-left" }
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Card = _resolveComponent("Card")
  const _component_KnHint = _resolveComponent("KnHint")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Menu = _resolveComponent("Menu")
  const _component_KnInputFile = _resolveComponent("KnInputFile")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Card, { class: "p-m-3" }, {
        header: _withCtx(() => [
          _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
            start: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.details')), 1)
            ]),
            end: _withCtx(() => [
              (_ctx.templateOptionEnabled('uploadable') || _ctx.templateOptionEnabled('downloadable'))
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    icon: "fas fa-ellipsis-v kn-cursor-pointer",
                    class: "p-button-text p-button-rounded p-button-plain",
                    onClick: _ctx.showMenu
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        content: _withCtx(() => [
          _createVNode("form", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("span", _hoisted_4, [
                _createVNode(_component_InputText, {
                  id: "activityName",
                  class: ["kn-material-input p-mb-2", {
                                    'p-invalid': _ctx.v$.activity.activityName.$invalid && _ctx.v$.activity.activityName.$dirty
                                }],
                  type: "text",
                  modelValue: _ctx.v$.activity.activityName.$model,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.activity.activityName.$model = $event)),
                  modelModifiers: { trim: true },
                  maxLength: "100",
                  onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.activity.activityName.$touch())),
                  "data-test": "activityName-input"
                }, null, 8, ["modelValue", "class"]),
                _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('documentExecution.dossier.headers.activity')) + " * ", 1)
              ]),
              _createVNode(_component_KnValidationMessages, {
                vComp: _ctx.v$.activity.activityName,
                additionalTranslateParams: {
                                fieldName: _ctx.$t('documentExecution.dossier.headers.activity')
                            }
              }, null, 8, ["vComp", "additionalTranslateParams"])
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_Button, {
                class: "kn-button p-button-text",
                disabled: _ctx.buttonDisabled || _ctx.launchButtonDisabled || _ctx.launchClicked,
                label: _ctx.$t('documentExecution.dossier.launchActivity'),
                onClick: _ctx.createNewActivity,
                "data-test": "input-button"
              }, null, 8, ["disabled", "label", "onClick"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Card, { class: "p-m-3" }, {
        header: _withCtx(() => [
          _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
            start: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.dossier.launchedActivities')), 1)
            ]),
            _: 1
          })
        ]),
        content: _withCtx(() => [
          (_ctx.showHint)
            ? (_openBlock(), _createBlock(_component_KnHint, {
                key: 0,
                title: 'documentExecution.dossier.title',
                hint: 'documentExecution.dossier.hint',
                "data-test": "hint"
              }, null, 8, ["title", "hint"]))
            : (_openBlock(), _createBlock(_component_DataTable, {
                key: 1,
                value: _ctx.dossierActivities,
                filters: _ctx.filters,
                "onUpdate:filters": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filters = $event)),
                scrollable: true,
                scrollHeight: "40vh",
                rows: 20,
                class: "p-datatable-sm kn-table",
                dataKey: "id",
                responsiveLayout: "stack",
                breakpoint: "960px",
                "data-test": "activities-table",
                sortField: "creationDate",
                sortOrder: -1
              }, {
                header: _withCtx(() => [
                  _createVNode("div", _hoisted_7, [
                    _createVNode("span", _hoisted_8, [
                      _hoisted_9,
                      _createVNode(_component_InputText, {
                        class: "kn-material-input",
                        modelValue: _ctx.filters['global'].value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters['global'].value = $event)),
                        type: "text",
                        placeholder: _ctx.$t('common.search'),
                        badge: "0"
                      }, null, 8, ["modelValue", "placeholder"])
                    ])
                  ])
                ]),
                empty: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
                ]),
                filter: _withCtx(({ filterModel }) => [
                  _createVNode(_component_InputText, {
                    type: "text",
                    modelValue: filterModel.value,
                    "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
                    class: "p-column-filter"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    field: "activity",
                    header: _ctx.$t('documentExecution.dossier.headers.activity'),
                    sortable: true
                  }, null, 8, ["header"]),
                  _createVNode(_component_Column, {
                    field: "creationDate",
                    header: _ctx.$t('common.creationDate'),
                    sortable: true,
                    dataType: "date"
                  }, {
                    body: _withCtx(({data}) => [
                      _createTextVNode(_toDisplayString(_ctx.formatDate(data.creationDate)), 1)
                    ]),
                    _: 1
                  }, 8, ["header"]),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
                    return (_openBlock(), _createBlock(_component_Column, {
                      field: col.field,
                      header: _ctx.$t(col.header),
                      key: col.field,
                      style: col.style,
                      class: "kn-truncated",
                      sortable: true
                    }, null, 8, ["field", "header", "style"]))
                  }), 128)),
                  _createVNode(_component_Column, {
                    header: "",
                    style: _ctx.dossierDescriptor.table.iconColumn.style,
                    onRowClick: false
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_Button, {
                        icon: "pi pi-download",
                        class: "p-button-link",
                        onClick: ($event: any) => (_ctx.downloadActivity(slotProps.data))
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_Button, {
                        icon: "pi pi-trash",
                        class: "p-button-link",
                        disabled: _ctx.dateCheck(slotProps.data),
                        onClick: ($event: any) => (_ctx.deleteDossierConfirm(slotProps.data)),
                        "data-test": "delete-button"
                      }, null, 8, ["disabled", "onClick"])
                    ]),
                    _: 1
                  }, 8, ["style"])
                ]),
                _: 1
              }, 8, ["value", "filters"]))
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_Menu, {
      id: "optionsMenu",
      ref: "optionsMenu",
      model: _ctx.menuButtons
    }, null, 8, ["model"]),
    (!_ctx.uploading)
      ? (_openBlock(), _createBlock(_component_KnInputFile, {
          key: 0,
          label: "",
          changeFunction: _ctx.startTemplateUpload,
          triggerInput: _ctx.triggerUpload
        }, null, 8, ["changeFunction", "triggerInput"]))
      : _createCommentVNode("", true)
  ], 64))
}